import type { CarlineGroup } from '../../@types/mapped';
import { getConfigureUrl } from '../utils/getConfigureLink';

export const filterNonConfigurableCarlines = (groups: CarlineGroup[]): CarlineGroup[] => {
  return groups
    .map((group) => ({
      ...group,
      carlines: group.carlines.filter((carline) => !!getConfigureUrl(carline)),
    }))
    .filter((group) => group.carlines.length > 0);
};

export const createCompareCheckboxId = (carlineId: string): string => `compare-chkbx-${carlineId}`;
